import { JSONLD } from 'lincd-jsonld/utils/JSONLD';
import { createNameSpace } from 'lincd/utils/NameSpace';
import { linkedOntology } from '../package.js';
//import all the exports of this file as one variable called _this (we need this at the end)
import * as _this from './profile-pics.js';
/**
 * Load the data of this ontology into memory, thus adding the properties of the entities of this ontology to the local graph.
 */
export var loadData = () => {
    if (typeof module !== 'undefined' && typeof exports !== 'undefined') {
        // CommonJS import
        return import('../data/profile-pics.json').then((data) => JSONLD.parse(data));
    }
    else {
        // ESM import
        //@ts-ignore
        return import('../data/profile-pics.json', { with: { type: 'json' } }).then((data) => JSONLD.parse(data.default));
    }
};
/**
 * The namespace of this ontology, which can be used to create NamedNodes with URI's not listed in this file
 */
export var ns = createNameSpace('http://lincd.org/ont/profile-pics/');
/**
 * The NamedNode of the ontology itself
 */
export var _self = ns('');
//A list of all the entities (Classes & Properties) of this ontology, each exported as a NamedNode
export var ProfilePicture = ns('ProfilePicture');
export var ProfilePictureSet = ns('ProfilePictureSet');
export var image = ns('image');
export var crop = ns('crop');
export var hasProfilePicture = ns('hasProfilePicture');
export var hasProfilePicture2 = ns('hasProfilePicture2');
export var hasProfilePicture3 = ns('hasProfilePicture3');
export var hasProfilePicture4 = ns('hasProfilePicture4');
export var hasProfilePicture5 = ns('hasProfilePicture5');
export var hasProfilePicture6 = ns('hasProfilePicture6');
export var hasProfilePictures = ns('hasProfilePictures');
export var profileSetupCompleted = ns('profileSetupCompleted');
//An extra grouping object so all the entities can be accessed from the prefix/name
export const profilePics = {
    ProfilePicture,
    ProfilePictureSet,
    image,
    crop,
    hasProfilePicture,
    hasProfilePicture2,
    hasProfilePicture3,
    hasProfilePicture4,
    hasProfilePicture5,
    hasProfilePicture6,
    hasProfilePictures,
    profileSetupCompleted,
};
//Registers this ontology to LINCD.JS, so that data loading can be automated amongst other things
linkedOntology(_this, ns, 'profile-pics', loadData, '../data/profile-pics.json');
//# sourceMappingURL=profile-pics.js.map